module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xWXcCb/tc-custom/9781685507572.jpg?1723406431963",
      "alt": "This image is the cover for the book The Nobleman and the Knave"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Nobleman and the Knave\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Timon wishes for the day when his dominating and demanding sister Leah is finally married to the rich and darkly handsome Sir Jocelyn. Then Timon dreams of being free to travel and live his own life."), _c('br'), _c('br'), _vm._v("Agapito is destined to be a sex slave for Jocelyn, but Agapito’s prayers are answered when the dashing Timon buys him instead."), _c('br'), _c('br'), _vm._v("When Timon rescues Agapito, he has no idea what changes to his life the act of charity will bring. Agapito is as beautiful as he is enigmatic, and friendship between them soon becomes love."), _c('br'), _c('br'), _vm._v("But one man still stands between them and happiness. Sir Jocelyn lives a dual life -- as a businessman with influence and a fiancée, and as a sexual taskmaster with a cruel streak. As Timon and Agapito discover, Jocelyn is as dangerous as he is dissolute.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Pelaam\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0